import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punnetothanecab() {



    const cardData = {

keyword: "Pune to Thane Cab",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable Pune to Thane Cab services for families, corporate travelers, students, and daily commuters. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for work, business meetings, or family visits, Rising Cab Service ensures a hassle-free and comfortable journey to Thane.",

topPlaces: [
    {
        title: "Upvan Lake",
        description:
            "Upvan Lake is one of the most popular scenic spots in Thane known for its calm waters, evening lights, and cultural festivals like Sanskruti Arts Festival. It is ideal for relaxation and photography."
    },
    {
        title: "Yeoor Hills",
        description:
            "Yeoor Hills is a natural forested area in Thane offering trekking trails, wildlife sightings, and fresh greenery, making it a favorite escape for nature lovers near Mumbai."
    },
    {
        title: "Tikuji-ni-Wadi",
        description:
            "Tikuji-ni-Wadi is a popular amusement and water park in Thane featuring rides, slides, and family entertainment options, making it a great weekend destination."
    },
    {
        title: "Korum Mall",
        description:
            "Korum Mall is one of Thane’s major shopping and entertainment hubs with branded stores, food courts, and cinema halls, attracting families and youngsters."
    },
    {
        title: "Suraj Water Park",
        description:
            "Suraj Water Park is a well-known theme water park in Thane with fun rides, slides, and cultural sculptures, often called the 'Pride of Maharashtra'."
    },
    {
        title: "Masunda Lake (Talao Pali)",
        description:
            "Masunda Lake, also known as Talao Pali, is a scenic lake in Thane offering boating, street food, and peaceful evening views."
    },
    {
        title: "Viviana Mall",
        description:
            "Viviana Mall is one of the largest malls in Thane featuring shopping brands, restaurants, entertainment zones, and multiplex cinema."
    },
    {
        title: "Sanjay Gandhi National Park (Nearby)",
        description:
            "Sanjay Gandhi National Park near Thane is a massive green reserve in Mumbai known for Kanheri Caves, wildlife, and trekking opportunities."
    },
    {
        title: "Ghodbunder Fort",
        description:
            "Ghodbunder Fort is a historic Portuguese-era fort in Thane offering heritage views and scenic surroundings near the creek area."
    },
    {
        title: "Thane Creek Flamingo Sanctuary (Nearby)",
        description:
            "Thane Creek Flamingo Sanctuary is famous for migratory flamingos and birdwatching, making it a unique eco-tourism attraction near Thane."
    }
],



services: [
    {
        name: "Pune to Thane Cab",
        description:
            "Rising Cab Service offers Pune to Thane Cab for safe, fast, and comfortable intercity travel via expressway routes. This service is ideal for daily business travel, family trips, office commuting, and weekend journeys. We provide well-maintained AC vehicles including hatchbacks, sedans, SUVs, Innova, and Innova Crysta with experienced drivers familiar with Mumbai–Pune expressway routes. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. With transparent pricing, 24x7 availability, and professional service, we ensure a smooth and stress-free journey between Pune and Thane."
    },
    {
        name: "Pune to Thane Taxi",
        description:
            "Book Pune to Thane Taxi with Rising Cab Service for affordable, safe, and comfortable travel. Our taxis are suitable for solo passengers, families, and corporate travelers who require reliable intercity transportation with clean vehicles and professional chauffeurs."
    },
    {
        name: "Cab from Pune to Thane",
        description:
            "Rising Cab Service provides Cab from Pune to Thane with flexible pickup options, AC vehicles, and experienced drivers ensuring smooth expressway travel and timely arrival."
    },
    {
        name: "Taxi from Pune to Thane",
        description:
            "Our Taxi from Pune to Thane service ensures safe and punctual travel with well-trained drivers, clean vehicles, and budget-friendly pricing for all types of passengers."
    },
    {
        name: "Pune to Thane Cab Service",
        description:
            "Rising Cab Service offers Pune to Thane Cab Service with easy booking, reliable transportation, and professional drivers ensuring a hassle-free travel experience."
    },
    {
        name: "Pune to Thane Taxi Fare",
        description:
            "Get transparent Pune to Thane Taxi Fare with no hidden charges. We offer competitive pricing suitable for one-way and round-trip expressway travel between Pune and Thane."
    },
    {
        name: "Pune to Thane One Way Cab",
        description:
            "Book Pune to Thane One Way Cab for cost-effective single-trip travel with comfortable vehicles and professional expressway-trained drivers."
    },
    {
        name: "Pune to Thane Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Thane Round Trip Taxi with flexible return timing, waiting options, and customized travel plans for business and family travelers."
    },
    {
        name: "Pune to Thane Cab Booking",
        description:
            "Our Pune to Thane Cab Booking service offers instant confirmation, multiple vehicle options, and 24x7 support for quick and easy travel planning."
    },
    {
        name: "Cheap Pune to Thane Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Thane Cab with budget-friendly fares while ensuring safety, comfort, and reliable expressway travel experience."
    },
    {
        name: "Best Pune to Thane Taxi",
        description:
            "Choose the Best Pune to Thane Taxi with Rising Cab Service for premium comfort, punctual service, and experienced drivers ensuring smooth highway travel."
    },
    {
        name: "Sedan Pune to Thane Cab",
        description:
            "Our Sedan Pune to Thane Cab is ideal for individuals and small families looking for affordable and comfortable expressway travel."
    },
    {
        name: "SUV Pune to Thane Taxi",
        description:
            "Book SUV Pune to Thane Taxi for spacious seating, extra luggage capacity, and comfortable group travel on long highway routes."
    },
    {
        name: "Innova Pune to Thane Cab",
        description:
            "Rising Cab Service offers Innova Pune to Thane Cab for family and group travel with premium comfort, smooth rides, and reliable expressway service."
    },
    {
        name: "Expressway Cab Pune Thane",
        description:
            "Our Expressway Cab Pune Thane service ensures fast, safe, and efficient travel using Mumbai–Pune expressway with experienced drivers and optimized routes."
    },
    {
        name: "Cab from Thane to Pune",
        description:
            "Rising Cab Service also provides Cab from Thane to Pune with reliable return trip options, comfortable vehicles, and professional drivers for smooth intercity travel."
    },
    {
        name: "Thane to Pune Cab Service",
        description:
            "Book Thane to Pune Cab Service for safe, affordable, and convenient travel with door-to-door pickup and drop facility."
    },
    {
        name: "Taxi from Thane to Pune",
        description:
            "Our Taxi from Thane to Pune service ensures timely pickup, comfortable seating, and professional drivers for a stress-free journey."
    },
    {
        name: "Pune to Virar Cab Service",
        description:
            "Rising Cab Service offers Pune to Virar Cab Service for long-distance travel with clean vehicles, experienced drivers, and affordable pricing."
    },
    {
        name: "Pune to Virar Taxi Service",
        description:
            "Book Pune to Virar Taxi Service for safe and comfortable intercity travel with flexible booking options and 24x7 availability."
    },
    {
        name: "Pune to Virar Cab Booking",
        description:
            "Our Pune to Virar Cab Booking service offers instant confirmation, multiple cab options, and reliable customer support for hassle-free travel."
    },
    {
        name: "Best Pune to Virar Cab",
        description:
            "Choose the Best Pune to Virar Cab for premium comfort, professional drivers, and smooth long-distance travel experience."
    },
    {
        name: "One Way Pune to Virar Cab",
        description:
            "Book One Way Pune to Virar Cab for economical single-trip travel with safe vehicles and experienced chauffeurs."
    },
    {
        name: "Round Trip Pune to Virar Taxi",
        description:
            "Rising Cab Service provides Round Trip Pune to Virar Taxi with flexible return scheduling and customized travel plans for families and corporate users."
    },
    {
        name: "Cheap Pune to Virar Cab",
        description:
            "We offer Cheap Pune to Virar Cab with budget-friendly fares while maintaining safety, comfort, and reliable service quality."
    },
    {
        name: "24x7 Pune to Virar Cab Service",
        description:
            "Book 24x7 Pune to Virar Cab Service with Rising Cab Service for round-the-clock availability and quick response anytime you need travel."
    },
    {
        name: "Outstation Cab Pune to Virar",
        description:
            "Our Outstation Cab Pune to Virar service ensures safe, comfortable, and reliable long-distance travel with professional drivers and clean vehicles."
    }
],

tableData: [
    ["Pune to Thane Cab", "Pune to Thane Taxi"],
    ["Cab from Pune to Thane", "Taxi from Pune to Thane"],
    ["Pune to Thane One Way Cab", "Pune to Thane Round Trip Taxi"],
    ["Pune to Thane Cab Service", "Pune to Thane Taxi Fare"],
    ["Cheap Pune to Thane Cab", "Best Pune to Thane Taxi"],
    ["Sedan Pune to Thane Cab", "SUV Pune to Thane Taxi"],
    ["Innova Pune to Thane Cab", "Expressway Cab Pune Thane"],
    ["Cab from Thane to Pune", "Thane to Pune Cab Service"],
    ["Taxi from Thane to Pune", "Pune to Virar Cab Service"],
    ["Pune to Virar Taxi Service", "Pune to Virar Cab Booking"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Thane Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Thane cab transportation for business travelers, families, tourists, students, and daily commuters seeking a smooth travel experience."
    },
    {
        WhyChooseheading: "Convenient Travel Between Two Major Cities",
        WhyChoosedescription: "Our cab service offers hassle-free connectivity between Pune and Thane for personal visits, official meetings, airport transfers, and leisure travel."
    },
    {
        WhyChooseheading: "Perfect for Corporate and Business Travel",
        WhyChoosedescription: "Professionals regularly choose our Pune to Thane cabs for meetings, conferences, client visits, and business-related transportation requirements."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger count and travel preferences."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you need a one-way drop, same-day return, weekend travel, or a customized itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available from All Pune Locations",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Safe and Professional Travel Experience",
        WhyChoosedescription: "Our trained drivers and regularly maintained vehicles ensure comfortable, secure, and stress-free travel throughout the journey."
    },
    {
        WhyChooseheading: "Suitable for Families and Group Travelers",
        WhyChoosedescription: "From solo travelers to large groups, we offer suitable vehicle options for vacations, family visits, events, and social gatherings."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently book Pune to Thane cabs?",
        answer: "Thane is a major residential, commercial, and business hub that attracts travelers for work, family visits, medical purposes, and leisure activities."
    },
    {
        question: "Can I book a one-way cab from Pune to Thane?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is most suitable for Pune to Thane travel?",
        answer: "Sedan cars, Ertiga, and Innova Crysta are among the most popular choices due to their comfort and spacious seating."
    },
    {
        question: "Are same-day return trips available?",
        answer: "Yes, customers can choose same-day return travel depending on their schedule and requirements."
    },
    {
        question: "Can business professionals use this service regularly?",
        answer: "Yes, many corporate travelers and executives use our Pune to Thane cab service for official travel and meetings."
    },
    {
        question: "Do you provide Tempo Travellers for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, and group transportation."
    },
    {
        question: "Can customers start the journey from Pune Airport?",
        answer: "Yes, pickup services are available from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "Is advance reservation recommended for Pune to Thane travel?",
        answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning."
    },
    {
        question: "Can multiple stops be included during the trip?",
        answer: "Yes, customers can customize their journey by adding sightseeing points, business locations, or personal stops."
    },
    {
        question: "How can I book a Pune to Thane Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akshay Bendre",
        feedback:
            "I frequently travel between Pune and Thane for business purposes, and Rising Cab Service has consistently delivered punctual and comfortable transportation every time.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rupal Shah",
        feedback:
            "A recent family visit to Thane was made extremely convenient with Rising Cab Service. The vehicle was clean, the driver was courteous, and the entire journey was enjoyable.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Thane Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-thane-cab.jpg",
"description": "Book Pune to Thane Cab Service with Rising Cab Service for safe, fast, and comfortable intercity travel via expressway. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-thane-cab"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Thane Cab | Expressway Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Thane Cab Service for fast and safe expressway travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to thane cab, pune to thane taxi, cab from pune to thane, taxi from pune to thane, pune to thane cab service, pune to thane taxi fare, pune to thane one way cab, pune to thane round trip taxi, pune to thane cab booking, cheap pune to thane cab, best pune to thane taxi, sedan pune to thane cab, suv pune to thane taxi, innova pune to thane cab, expressway cab pune to thane"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punnetothanecab;